<app-menu *ngIf="currentUser"></app-menu>
<router-outlet></router-outlet> 
